// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — button.styled.classic.js, новая — button.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './button.styled.classic';
import * as cp from './button.styled.cp';

export const ButtonStyled = isCp ? cp.ButtonStyled : classic.ButtonStyled;
export const Buttons = isCp ? cp.Buttons : classic.Buttons;
